import React from 'react';

const Loading = () => {
  return (
    <div style={{ transform: 'translate(0, 80%)' }} height="100%" width="100%">
      <div className="spinner">
        <div className="bubble-1" />
        <div className="bubble-2" />
      </div>
    </div>
  );
};

export default Loading;
